import { CreditCard, Gift, Landmark, Smartphone } from "lucide-react";
import { Card3D } from "@/components/soon/Card3D";
import { SoonPage } from "@/components/soon/SoonPage";

const FEATURES = [
  [Landmark, "Votre IBAN", "Un IBAN à votre nom pour recevoir votre salaire, vos remboursements et faire vos virements."],
  [CreditCard, "Carte virtuelle", "Une carte virtuelle disponible immédiatement, à bloquer ou débloquer en un geste depuis CASHMY."],
  [Smartphone, "Apple Pay et Google Pay", "Payez avec votre téléphone ou votre montre, partout où le sans contact est accepté."],
  [Gift, "Vos cagnottes reçues directement", "L'argent de vos cagnottes arrive directement sur votre compte en ligne, sans délai."],
];

export default function OnlineAccount() {
  return (
    <SoonPage testid="account-soon" eyebrow="Compte en ligne + carte" title="Votre compte en ligne, au cœur du foyer"
      text="Un compte en ligne avec IBAN et carte, directement dans CASHMY, pour piloter les dépenses de votre foyer au même endroit."
      visual={<Card3D />} features={FEATURES} interest="compte" other={["/cagnottes", "Découvrir aussi les cagnottes entre proches"]} />
  );
}
